/** Only the anonymous form may render inside a frame, including after SPA navigation. */
export function canRenderInFrame(pathname: string, framed: boolean): boolean {
  return !framed || /^\/palvelupyynto\/upotus\/[a-z0-9]+(?:-[a-z0-9]+)*\/?$/.test(pathname);
}
